import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M145-146q-32 0-56-24-23-24-23-55v-510q0-32 23-56 24-24 56-24h237q16 0 31 7t26 18l42 42h334q32 0 56 24t24 55v444q0 31-24 55t-56 24H145Zm0-79h670v-444H448l-66-66H145v510Zm0 0v-510 510Z"/>',
  f: '<path d="M145-146q-32 0-56-24-23-24-23-55v-510q0-32 23-56 24-24 56-24h237q15 0 30 7 16 7 26 18l43 42h334q32 0 56 24t24 55v444q0 31-24 55t-56 24H145Z"/>',
};

export default data;
